const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoodAndRestaurant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "restaurants map location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M204.806,240.172c-17.956-24.626-26.828-53.426-24.984-81.1a123.643,123.643,0,0,1,35.6-79.2,114.479,114.479,0,0,1,61.862-32.31,117.079,117.079,0,0,0-20-1.711,114.632,114.632,0,0,0-81.862,34.021,123.643,123.643,0,0,0-35.6,79.2c-1.844,27.679,7.028,56.479,24.984,81.1L257.28,363.8l20-26.737Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.728,470.37,426.407,293.141a6,6,0,0,0-5.727-4.212H317.723v12h9.738l9.191,57.439a6,6,0,0,0,5.925,5.052h93.2L449.3,406.74H255.817a6,6,0,0,0-6,6v53.418H187.076l5-88.423a6,6,0,0,0-5.99-6.339H76.7l24.032-70.467H199.4v-12H96.442a6,6,0,0,0-5.678,4.063L30.321,470.222A6,6,0,0,0,36,478.158H476a6,6,0,0,0,5.728-7.788ZM347.693,351.42l-8.079-50.491h76.653l15.76,50.491ZM72.61,383.4H179.732l-4.675,82.762H44.386Zm189.207,82.762V418.74H453.041l14.8,47.418Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.653,71.4a127.5,127.5,0,0,0-180.745,0,135.622,135.622,0,0,0-39.059,86.875c-2.033,30.474,7.649,62.068,27.3,89.023l97.323,130.1a6,6,0,0,0,9.609,0l97.318-130.1c19.721-26.295,29.419-57.915,27.311-89.019A135.637,135.637,0,0,0,347.653,71.4Zm2.146,168.71L257.28,363.8,164.806,240.172c-17.956-24.626-26.828-53.426-24.984-81.1a123.643,123.643,0,0,1,35.6-79.2,115.5,115.5,0,0,1,163.726,0,123.652,123.652,0,0,1,35.6,79.221C376.655,187.337,367.8,216.111,349.8,240.113Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.722,88.784a6,6,0,0,0-6,6v40.35a13.266,13.266,0,0,1-7.266,11.814V94.784a6,6,0,0,0-12,0v52.164a13.266,13.266,0,0,1-7.265-11.814V94.784a6,6,0,0,0-12,0v40.35a25.307,25.307,0,0,0,19.265,24.539v18.8a19.337,19.337,0,0,0-13.311,18.346v61.507a6,6,0,0,0,6,6h26.624a6,6,0,0,0,6-6V196.817a19.337,19.337,0,0,0-13.313-18.346v-18.8a25.306,25.306,0,0,0,19.266-24.539V94.784A6,6,0,0,0,240.722,88.784Zm-11.953,163.54H214.145V196.817a7.312,7.312,0,1,1,14.624,0Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.712,86.165l-12.528.2a27.17,27.17,0,0,0-26.424,27.009V259.836a6,6,0,0,0,6,6h17.348a6,6,0,0,0,6-6V213.6h9.7a6,6,0,0,0,6-6V92.164a6,6,0,0,0-6.1-6Zm-21.6,167.671H282.76V213.6h5.348Zm15.7-52.236H282.76V113.375a15.094,15.094,0,0,1,14.651-15.011l6.4-.1Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodAndRestaurant);
export default __webpack_public_path__ + "static/media/food-and-restaurant.cc77a726cbeae5788a0c0d3332159f71.svg";
export { ForwardRef as ReactComponent };